import _regeneratorRuntime from "/Users/lucky.zhang/workspaces/workspace_go/src/routerman/web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/lucky.zhang/workspaces/workspace_go/src/routerman/web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { getPolicyPathByAuthorityId } from '@/api/casbin';
export var api = {
  namespaced: true,
  state: {
    apis: []
  },
  mutations: {
    setApis: function setApis(state, apis) {
      state.apis = apis;
    }
  },
  actions: {
    getUserApis: function getUserApis(_ref, data) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var commit, res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit;
              _context.next = 3;
              return getPolicyPathByAuthorityId(data);
            case 3:
              res = _context.sent;
              if (res.code == 0 && res.data.paths) {
                commit('setApis', res.data.paths);
              }
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  },
  getters: {
    apis: function apis(state) {
      return state.apis;
    },
    authAPI: function authAPI(state) {
      var apiArr = [];
      state.apis.forEach(function (item) {
        var path = item.path;
        apiArr.push(path.replace('/v1', '') + '@' + item.method);
      });
      return apiArr;
    }
  }
};